var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-live-list-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-live-list-detail__withData",attrs:{"value":_vm.currentLive},on:{"deleteLive":_vm.toDeleteLive}})}
var staticRenderFns = []

export { render, staticRenderFns }